var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOfferTradeCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2499_4875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 118,
    height: 118,
    rx: 59,
    fill: "#F4F9FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.6493 22.2231C63.3044 17.4432 44.8816 14.5898 27.3806 16.7115C19.352 17.687 10.9625 19.9258 4.78252 25.4324C-3.39241 32.7096 -7.73351 44.7765 -9.97235 55.2191C-13.177 70.1539 -8.83585 84.3717 2.33882 94.9363C11.6502 103.716 23.8492 108.847 36.1604 112.383C49.9592 116.341 64.202 118.544 78.5519 118.938C91.9947 119.309 104.501 118.255 114.959 108.861C122.021 102.521 127.016 94.0486 129.811 84.9619C133.645 72.5195 132.601 59.6674 125.421 48.6882C118.592 38.2846 107.701 30.983 96.0578 26.9932C91.0533 25.291 85.9025 23.6668 80.6493 22.2231Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122 27H71V119H122V27Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117 38H75V102H117V38Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M96 116C98.7614 116 101 113.761 101 111C101 108.239 98.7614 106 96 106C93.2386 106 91 108.239 91 111C91 113.761 93.2386 116 96 116Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M107 31H92V33H107V31Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5 35C87.8807 35 89 33.8807 89 32.5C89 31.1193 87.8807 30 86.5 30C85.1193 30 84 31.1193 84 32.5C84 33.8807 85.1193 35 86.5 35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9693 80.4414L83.2773 84.5807C82.9821 84.9106 82.6199 85.1625 82.219 85.3168C81.8181 85.471 81.3894 85.5235 80.9665 85.47C80.5435 85.4165 80.1379 85.2585 79.7813 85.0084C79.4247 84.7583 79.1268 84.4229 78.911 84.0285L74.1439 75.2887C74.0117 75.0471 73.9132 74.7859 73.8516 74.5135C73.6441 73.5762 73.0689 71.2912 72.437 71.0328C71.6355 70.7136 71.4374 72.8264 71.4374 72.8264C71.4374 72.8264 69.1317 71.1747 68.1368 72.8264C67.5427 73.8144 68.9997 75.1215 70.2822 76.0234C71.3536 76.7728 72.1514 77.8967 72.5408 79.2051C73.762 83.3648 76.7514 92.1906 80.269 92.9151C84.8804 93.8727 93 86.4097 93 86.4097L86.9693 80.4414Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6061 80.371L83.6918 84.4381C83.3788 84.7622 82.9948 85.0097 82.5698 85.1613C82.1447 85.3129 81.6902 85.3644 81.2418 85.3118C80.7934 85.2593 80.3633 85.1041 79.9853 84.8583C79.6072 84.6126 79.2914 84.283 79.0626 83.8955L74.3743 76.2441C74.2341 76.0067 74.4912 76.5959 74.4259 76.3283C74.2059 75.4073 74.6783 76.7432 74.0084 76.4894C73.1586 76.7346 72.9123 76.9798 72.9123 76.9798C72.2824 77.9505 70.075 76.8294 71.4347 77.7155C72.1735 79.1868 71.7921 78.2365 72.1735 79.1869C73.4683 83.2739 76.6504 92.9196 80.5465 92.9196C85.4356 93.8604 94 86.2352 94 86.2352L87.6061 80.371Z",
    fill: "#007FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5 66.5C95.5 66.5 86.3578 73.0541 88.2291 83.3351C89.586 90.7831 88.523 86.7128 88.3173 92.3883L88.2291 96L104.463 95.5223C104.463 95.5223 103.429 88.404 105.443 83.3351C107.456 78.2663 111.984 65.148 95.5 66.5Z",
    fill: "#007FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.17 58L101 66.9761L95 67L96.804 60.4602L100.17 58Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M101.043 69C101.043 69 93.0322 71.3185 95.5557 77.9825C98.0792 84.6464 102.107 88.8723 98.0544 90.9997C94.002 93.127 88 96 88 96H101.855L105.15 92.5246L108 82.4857L101.043 69Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M96.6429 61.7972C97.5243 61.6945 98.3433 61.4175 99 61C99 61 98.712 62.576 96 64L96.6429 61.7972Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7133 56.4218C94.7133 56.4218 93.9744 59.1483 94.0573 61.0691C94.0753 61.4441 94.2305 61.7923 94.4888 62.0374C94.7471 62.2825 95.0876 62.4046 95.4356 62.377C95.9935 62.3666 96.5409 62.1825 97.0119 61.8467C97.4829 61.5109 97.8574 61.0378 98.0904 60.4843L99.3129 58.1961C99.5144 57.7136 99.5735 57.1792 99.4818 56.6671C99.3901 56.1549 99.1522 55.6904 98.8011 55.3381C97.5701 53.945 95.0878 54.7358 94.7133 56.4218Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0005 95.5L88.5126 102H107L104.5 94L88.0005 95.5Z",
    fill: "#252F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98 59.0994C98 59.0994 98.0346 57.8931 98.6098 58.0077C99.185 58.1223 99.1434 59.869 98.3569 60L98 59.0994Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3226 58.1759L93.2271 59.073C93.1854 59.1271 93.1529 59.1936 93.1329 59.2663C93.1129 59.339 93.1058 59.4155 93.1125 59.4887C93.1191 59.5619 93.1392 59.6293 93.1709 59.6848C93.2026 59.7402 93.2449 59.7819 93.2937 59.8058L94.3059 59.8719L94.3226 58.1759Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.9523 57.9161C97.9523 57.9161 96.5041 60.1244 98.6981 61.9377C101.252 59.8931 102.649 56.8491 102.475 57.8532C103.068 54.4281 102.295 58.9443 102.376 56.9847C103.092 52.484 94.5202 51.412 94.0038 53.9706C93.4875 56.5292 97.9523 57.9161 97.9523 57.9161Z",
    fill: "#3E4756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.44 68.895C101.882 68.5431 102.396 68.2855 102.948 68.1393C103.501 67.9931 104.079 67.9615 104.645 68.0467C105.211 68.1319 105.752 68.332 106.232 68.6336C106.712 68.9352 107.12 69.3316 107.43 69.7966C109.979 73.5393 111.219 77.9711 110.968 82.4428C110.41 91.9357 112.529 97.6899 102.228 95.5563C94.716 93.9985 85.5891 82.1076 85.5891 82.1076C85.5891 82.1076 82.5354 80.1581 84.8942 77.2833C87.253 74.4085 88.5451 81.8052 88.5451 81.8052C88.5451 81.8052 102.201 92.5815 104.697 89.7114C106.865 87.1765 95.0194 74.1253 101.44 68.895Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.467 68.895C101.908 68.5431 102.42 68.2855 102.971 68.1393C103.522 67.9931 104.099 67.9615 104.663 68.0467C105.228 68.1319 105.767 68.332 106.246 68.6336C106.724 68.9352 107.131 69.3316 107.44 69.7966C109.982 73.5393 111.219 77.9711 110.968 82.4428C110.412 91.9357 112.525 97.6899 102.253 95.5563C94.7624 93.9985 86 83.3474 86 83.3474C86 83.3474 86.0518 84.1044 88.4038 81.2296C88.8846 81.022 89.1213 81.2296 89.1213 81.2296C89.1213 81.2296 101.433 91.1426 103.922 88.2726C106.084 85.7377 95.0649 74.1253 101.467 68.895Z",
    fill: "#2995DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 16H-1V108H50V16Z",
    fill: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 27H3V91H46V27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.56,
    d: "M25 104C27.7614 104 30 101.761 30 99C30 96.2386 27.7614 94 25 94C22.2386 94 20 96.2386 20 99C20 101.761 22.2386 104 25 104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M35 19H21V22H35V19Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23C16.8807 23 18 22.1046 18 21C18 19.8954 16.8807 19 15.5 19C14.1193 19 13 19.8954 13 21C13 22.1046 14.1193 23 15.5 23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0036 66.6245C36.0036 66.6245 35.6947 78.0359 40.8298 80.2942C47.2101 83.1121 54.2999 76.7969 57.3549 73.5693C58.2374 72.626 59.3996 72.0157 60.6561 71.8356C61.7635 71.711 62.791 71.1791 63.5518 70.3367C65.2941 68.3382 61.5007 66.5096 59.9611 67.9985C60.0333 67.8714 60.0774 67.7293 60.0903 67.5824C60.1031 67.4356 60.0844 67.2876 60.0355 67.1491C59.9866 67.0106 59.9087 66.885 59.8074 66.7814C59.7061 66.6777 59.5839 66.5986 59.4495 66.5496C58.9669 66.2698 58.5422 66.9793 58.2574 67.7737C58.0568 68.3478 57.7366 68.8692 57.3196 69.3009C56.9026 69.7327 56.3989 70.0641 55.8443 70.2718L48.8752 72.8298C48.4092 73.019 47.903 73.0764 47.4084 72.9963C46.9139 72.9162 46.4488 72.7015 46.0609 72.3741C45.6729 72.0467 45.376 71.6184 45.2005 71.1331C45.0251 70.6478 44.9774 70.1229 45.0624 69.6123L45.6561 66L36.0036 66.6245Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1745 50C38.1745 50 47.2442 54.0749 45.8553 69L37 68.1997L38.1745 50Z",
    fill: "#68E1FD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.36,
    d: "M38.1745 50C38.1745 50 47.2442 54.0749 45.8553 69L37 68.1997L38.1745 50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5234 37L26 45.9506L31 47L30.8271 40.0635L28.5234 37Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.31,
    d: "M31 41.3159C30.5989 41.0544 30.2517 40.5968 30.0015 40C30.0015 40 29.9188 41.8925 30.9969 44L31 41.3159Z",
    fill: "#CE8172"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1872 46.0802L29.2757 46.7297C29.2757 46.7297 43.3805 48.27 43.969 56.3354C44.5576 64.4009 36.5616 85 36.5616 85H15.1611C15.1611 85 -1.969 43.9494 26.1872 46.0802Z",
    fill: "#3E4756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1334 47.5219C33.1334 47.5219 35.7252 71.7936 31.9445 84C31.9445 84 30.6932 56.695 26 46C26.0268 46 30.3424 46.7531 33.1334 47.5219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2499_4875)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 47.7143L32.7892 49.7523L30.3558 48.1839L28.2936 50L25 46C29.8901 46.2148 28.2109 46.4759 33 47.7143Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M33.2161 48L37 60.6555L35.1281 67.9484L36.4735 74.3484L32 84C32 84 35.9532 77.6516 33.2161 48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8471 47.5805C30.7453 47.4352 30.628 47.3297 30.5025 47.2706C30.3389 47.1822 30.1722 47.1138 30.0035 47.0656C29.8061 46.9781 29.5999 46.9781 29.4025 47.0656C29.3007 47.1217 29.2094 47.2274 29.1384 47.371C29.0675 47.5146 29.0196 47.6908 29 47.8804C29 48.1603 29.1434 48.4102 29.2592 48.5551C29.4332 48.8037 29.6425 48.958 29.8629 49L30.8692 48.7801C30.9629 48.7801 31.0153 48.0903 30.996 47.9653C30.9675 47.8141 30.9159 47.6806 30.8471 47.5805Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1962 49L30 49.2218C30 49.2218 30.9963 63.5678 30.8685 72.1371L31.9435 83C31.9435 83 34.1164 77.2082 33.9951 70.3225C33.9886 70.3376 32.8349 56.9695 31.1962 49Z",
    fill: "#003353"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M26 46L26.3758 65.5544L29.4269 67.9183L28.1703 74.4189L32 84C32 84 30.6563 56.559 26 46Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9831 37.3622C33.9831 37.3622 33.7006 39.7702 32.8112 41.2833C32.727 41.4293 32.6057 41.561 32.4545 41.6707C32.3032 41.7805 32.125 41.866 31.9303 41.9224C31.7355 41.9788 31.5281 42.0049 31.3201 41.9992C31.112 41.9935 30.9076 41.9562 30.7185 41.8893C30.0819 41.706 29.5287 41.3845 29.1264 40.964C28.7241 40.5435 28.4902 40.0422 28.4532 39.5214L28.0033 37.314C27.9751 36.8643 28.1289 36.4189 28.4436 36.0388C28.7583 35.6588 29.2185 35.3626 29.7611 35.191C31.7387 34.4726 34.229 35.9094 33.9831 37.3622Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.09,
    d: "M19.4899 50C19.4899 50 26.7578 54.2825 25.0862 63.9696C23.4146 73.6567 20.5801 76.9936 26.593 75.6363C32.6059 74.279 35.077 71.2264 35.077 71.2264C35.077 71.2264 39.4038 74.7935 35.077 77.5031C30.7502 80.2128 24.902 80.203 23.933 85H14.8095C14.8095 85 14.0681 82.8979 13.0894 80.252C12.1107 77.606 19.4899 50 19.4899 50Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8186 37.2988C31.8883 37.1703 30.9762 36.9343 30.1006 36.5955C30.2954 37.0499 30.3515 37.5516 30.262 38.0377C30.1724 38.5238 29.9412 38.9727 29.5972 39.3283C29.2747 39.6812 28.8392 39.9113 28.3654 39.9791C27.8916 40.047 27.4089 39.9483 27 39.7L27.7349 35.8772C27.8198 35.3279 28.0517 34.8116 28.4061 34.3828C28.7604 33.954 29.2241 33.6286 29.7482 33.4408C30.2037 33.2768 30.6695 33.1425 31.1425 33.0389C32.3253 32.7928 33.8152 33.8175 34.9427 33.2499C35.0556 33.1933 35.1814 33.1669 35.3076 33.1734C35.4338 33.1799 34.2952 33.1365 35.0895 33.2499C34.3694 33.4039 34.9409 33.3885 35 33.5C35.0591 33.6115 34.5039 33.8739 34.5 34C34.4648 35.1956 35.4309 36.9371 33.7346 37.2737C33.4325 37.3296 33.1234 37.3381 32.8186 37.2988Z",
    fill: "#3E4756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9896 39.2437C29.9896 39.2437 30.112 38.0683 29.5172 38.0019C28.9224 37.9355 28.7389 39.6321 29.5172 40L29.9896 39.2437Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M50 88C59.3888 88 67 80.3888 67 71C67 61.6112 59.3888 54 50 54C40.6112 54 33 61.6112 33 71C33 80.3888 40.6112 88 50 88Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 88C59.3888 88 67 80.3888 67 71C67 61.6112 59.3888 54 50 54C40.6112 54 33 61.6112 33 71C33 80.3888 40.6112 88 50 88Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M49.9895 84.5384C59.4961 84.5384 67.2027 76.8318 67.2027 67.3252C67.2027 57.8187 59.4961 50.1121 49.9895 50.1121C40.483 50.1121 32.7764 57.8187 32.7764 67.3252C32.7764 76.8318 40.483 84.5384 49.9895 84.5384Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.08,
    d: "M50 88C59.3888 88 67 80.3888 67 71C67 61.6112 59.3888 54 50 54C40.6112 54 33 61.6112 33 71C33 80.3888 40.6112 88 50 88Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 85C59.3888 85 67 77.165 67 67.5C67 57.835 59.3888 50 50 50C40.6112 50 33 57.835 33 67.5C33 77.165 40.6112 85 50 85Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7762 60.0284C50.2629 59.9347 50.4332 60.0659 50.5306 60.5249L50.735 61.5039C52.6818 61.3915 53.9862 62.0941 55.1154 63.5321C55.4658 63.9631 55.4171 64.2394 54.9061 64.5908L53.9959 65.2184C53.5676 65.5276 53.3194 65.4714 52.9495 65.0451C52.632 64.5906 52.171 64.2464 51.6346 64.0634C51.0983 63.8803 50.515 63.8682 49.9709 64.0287C48.209 64.3706 47.5081 65.0264 47.7466 66.1646C47.9023 66.9 48.72 67.2232 49.4598 67.2232C49.9735 67.2312 50.4872 67.2078 50.9978 67.153C51.9467 67.0197 52.9107 67.0197 53.8596 67.153C54.3343 67.2021 54.7951 67.3372 55.2176 67.5511C55.663 67.8519 56.0418 68.235 56.3317 68.6781C56.6217 69.1212 56.8171 69.6155 56.9064 70.1321C57.3591 72.3055 56.1569 74.0761 53.5676 74.9755L53.7818 76.0107C53.8791 76.4791 53.7818 76.6571 53.2951 76.7508L52.1562 76.9709C51.6695 77.0646 51.4796 76.9381 51.3823 76.5025L51.1682 75.486C49.0412 75.6312 47.44 74.8818 46.3789 73.2236C46.3159 73.1429 46.2728 73.0494 46.2529 72.9503C46.233 72.8512 46.2368 72.749 46.264 72.6515C46.2912 72.554 46.3411 72.4638 46.4099 72.3876C46.4787 72.3114 46.5647 72.2513 46.6612 72.2118L47.6006 71.6544C48.0873 71.3734 48.3355 71.4483 48.6713 71.9027C49.3625 72.9332 50.4089 73.3079 51.8203 73.0362C53.7282 72.6615 54.5556 71.898 54.3123 70.7223C54.2704 70.4468 54.1343 70.1925 53.9253 69.9999C53.7164 69.8073 53.4466 69.6873 53.1588 69.659C52.452 69.5586 51.7338 69.5586 51.027 69.659C50.0656 69.7924 49.0884 69.7798 48.1311 69.6215C47.6607 69.5596 47.2057 69.4168 46.7878 69.1999C46.3427 68.9183 45.9629 68.5511 45.6723 68.1215C45.3816 67.6918 45.1864 67.209 45.0989 66.7033C44.6463 64.5486 45.7511 62.8389 48.3355 61.9817L48.1311 61.0074C48.0338 60.539 48.1652 60.3563 48.6178 60.2626L49.7762 60.0284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65329 65.4638C9.65329 65.4638 6.82111 79.2503 12.9506 79.9321C17.5723 80.4494 24.9836 77.882 29.512 76.6104C31.4766 76.0592 32.4245 75.8029 33.9323 74.4491C35.7348 72.8245 38.2396 71.6689 36.2947 70.1265C32.8567 67.385 30.401 72.0606 30.401 72.0606C27.5122 72.8844 24.5351 73.3712 21.5309 73.5111C20.9672 73.5261 20.4077 73.4114 19.8969 73.1761C19.3861 72.9409 18.9381 72.5915 18.5885 72.1558C18.239 71.7202 17.9975 71.2102 17.8833 70.6666C17.7692 70.1229 17.7854 69.5605 17.9308 69.0241L19.0752 64.7934C19.0752 64.7934 12.5658 55.8275 9.65329 65.4638Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5958 39L33.9757 40.305C33.9948 40.3787 34.0028 40.4589 33.9991 40.5387C33.9954 40.6186 33.9801 40.6959 33.9545 40.764C33.9289 40.8321 33.8937 40.8891 33.8519 40.9302C33.8101 40.9712 33.7629 40.9952 33.7143 41H33L33.5958 39Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 85V91H38L36.1575 85H16Z",
    fill: "#252F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6444 65.6322C65.2668 66.092 65.0442 66.6719 65.0116 67.2807C64.9731 67.608 65.0309 67.9399 65.1772 68.231C65.2811 68.396 65.4155 68.5369 65.5722 68.6453C66.1879 69.0957 67.1349 69.1678 67.6275 68.5642C67.8874 68.1948 68.018 67.741 67.997 67.2807C67.997 66.7402 68.0564 65.6728 67.6487 65.2584C67.1009 64.6999 66.0733 65.1503 65.6444 65.6322Z",
    fill: "#F4A28C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1172 50.0489C8.89875 54.5205 6.5537 61.1563 9.04204 75.0664C9.41436 77.1245 10.3888 78.9452 11.9698 80.336C13.5508 81.7269 16.8493 80.5755 18.5572 80.0965L30.512 76.2641L31 71.7131L23.9247 72.9107C23.3729 72.8321 21.465 73.2097 20.9969 72.9107C20.4088 72.9107 20.509 72.9107 20.021 72.6712C19.5331 72.1921 19.9194 72.5714 19.5331 72.1921C19.0451 71.7131 18.8011 71.7131 18.8011 71.234C20.5777 65.4592 21.8089 59.959 21.0971 52.4994C20.6712 47.9708 14.785 46.3402 12.1172 50.0489Z",
    fill: "#3E4756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5711 34.704L36.4087 36.9011L35.5911 34.83C35.5911 34.83 35.7092 30.3095 33.5569 29.2767C31.4047 28.2438 27.2098 29.0644 26.5711 34.704Z",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.461 58.7033L92.4375 52.8024L94.8533 51.5611C94.8533 51.5611 98.3316 47.3212 101.182 48.106C104.032 48.8907 107.337 53.0183 103.461 58.7033Z",
    fill: "#FFD200"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 119,
    height: 119,
    rx: 59.5,
    stroke: "#E6F2FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2499_4875",
    x: 21,
    y: 46,
    width: 16,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2499_4875"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2499_4875",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2499_4875"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 118,
    height: 118,
    rx: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfferTradeCredit);
export default __webpack_public_path__ + "static/media/OfferTradeCredit.8aac5aef985f373ce4878bb5eacc6820.svg";
export { ForwardRef as ReactComponent };